// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"f150c6c6","803":"269b10eb"}[chunkId] + ".chunk.js";
};